<template>
  <div class="row">
    <div class="col-12">
      <card card-body-classes="table-full-width" no-footer-line>
        <h4 slot="header" class="card-title text-purple">
          {{ $t("app.modules.customers.title") }}
        </h4>
        <div class="col-md-12">
          <div class="row">
            <!-- Buscar Razón Social -->
            <div class="col-2">
              {{ $t("app.modules.customers.client_code_SAP") }}

              <fg-input>
                <el-input
                  type="text"
                  class="mb-2"
                  clearable
                  style="width: 200px"
                  :placeholder="$t('app.modules.customers.client_code_SAP')"
                  v-model="searchCte"
                  aria-controls="datatables"
                >
                </el-input>
              </fg-input>
            </div>

            <!-- Buscar Razón Social -->
            <div class="col-2">
              {{ $t("app.modules.customers.business_name") }}

              <fg-input>
                <el-input
                  type="text"
                  class="mb-2"
                  clearable
                  style="width: 200px"
                  :placeholder="$t('app.modules.customers.business_name')"
                  v-model="searchRazonSocial"
                  aria-controls="datatables"
                >
                </el-input>
              </fg-input>
            </div>

            <!-- Buscar RFC -->
            <div class="col-2">
              {{ $t("app.modules.customers.rfc") }}

              <fg-input>
                <el-input
                  type="text"
                  class="mb-2"
                  clearable
                  style="width: 200px"
                  :placeholder="$t('app.modules.customers.rfc')"
                  v-model="searchRFC"
                  aria-controls="datatables"
                >
                </el-input>
              </fg-input>
            </div>

            <!-- Fecha Confirmación
          <div class="col-2">
            {{ $t("app.modules.customers.last_purchase_date") }}

            <fg-input>
              <el-date-picker
                type="date"
                placeholder="Date Picker"
                v-model="iniCreateDate"
              >
              </el-date-picker>
            </fg-input>
          </div> -->

            <!-- Fecha Creación
          <div class="col-2">
            {{ $t("app.modules.customers.last_purchase_date") }}

            <fg-input>
              <el-date-picker
                type="date"
                placeholder="Date Picker"
                v-model="endCreateDate"
              >
              </el-date-picker>
            </fg-input>
          </div>  -->

            <!--
            <div :class="sizes">
              {{ $t("app.modules.candidates.headers.date_assignment") }}
              <fg-input>
                <el-date-picker
                  type="date"
                  :placeholder="
                    this.$t('app.modules.candidates.headers.date_assignment')
                  "
                  v-model="assignDate"
                >
                </el-date-picker>
              </fg-input>
            </div>
            <div :class="sizes">
              {{ $t("app.modules.candidates.headers.application_date") }}
              <fg-input>
                <el-date-picker
                  type="date"
                  :placeholder="
                    this.$t('app.modules.candidates.headers.application_date')
                  "
                  v-model="applicateDate"
                >
                </el-date-picker>
              </fg-input>
            </div>
            <div :class="sizes">
              {{ $t("app.general.search") }}
              <fg-input>
                <el-input
                  type="search"
                  clearable
                  prefix-icon="el-icon-search "
                  style="width: 300px"
                  :placeholder="$t('app.general.search')"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </fg-input>
            </div>
            -->
          </div>

          <el-table stripe style="width: 100%" :data="queriedData">
            <el-table-column
              prop="idClienteSAP"
              :label="this.$t('app.modules.customers.client_code_SAP')"
              width="250"
            >
            </el-table-column>
            <el-table-column
              prop="razonSocial"
              :label="this.$t('app.modules.customers.business_name')"
              sortable
              width="200"
            >
            </el-table-column>

            <el-table-column
              prop="rfc"
              :label="this.$t('app.modules.customers.rfc')"
              sortable
              width="200"
            >
            </el-table-column>

            <el-table-column
              prop="fechaConfirmacionPedido"
              :label="$t('app.modules.customers.last_purchase_date')"
              width="350"
            >
            </el-table-column>

            <el-table-column
              :min-width="135"
              fixed="right"
              :label="$t('app.general.actions')"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          DetailsItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.customers.details") }}
                      </n-button>
                    </div>

                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          OrdersItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.customers.orders") }}
                      </n-button>
                    </div>

                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          TrakinItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.customers.trakin") }}
                      </n-button>
                    </div>

                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          BillingItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.customers.billing") }}
                      </n-button>
                    </div>

                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          AccountItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.modules.account_statements.name") }}
                      </n-button>
                    </div>

                    <!--
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          AssignItem(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        size="sm"
                        class="options-button"
                        round
                      >
                        {{
                          $t("app.modules.candidates.headers.assign_candidate")
                        }}
                      </n-button>
                    </div>
                    -->
                  </div>

                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>

      <clientes-detalles />
      <!--
      <prospectos-detalles />
      <prospectos-asignar />
      -->
    </div>
  </div>
</template>

<script>
import Fuse from "fuse.js";

export default {
  components: {
    ClientesDetalles: () => import("./clientesDetalles")
  },

  /*
watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */

  /*
    searchQuery(value) {
      this.generalFilter();
    },
    assignDate(value) {
      this.generalFilter();
    },
    applicateDate(value) {
      this.generalFilter();
    }
  },*/
  computed: {
    queriedData() {
      let result = this.tableData;

      // filter by create date
      /*result =
        this.iniCreateDate > new Date("1900-01-01") &&
        this.endCreateDate > new Date("1900-01-01")
          ? (result = result.filter(
              d =>
                new Date(d.fechaConfirmacionPedido) >= this.iniCreateDate &&
                new Date(d.fechaConfirmacionPedido) <= this.endCreateDate
            ))
          : result;
        */
      // filter by business name

      result =
        this.searchRazonSocial.length > 0
          ? result.filter(d =>
            d.razonSocial
              .toLowerCase()
              .includes(this.searchRazonSocial.toLowerCase())
          )
          : result;

      result =
        this.searchRFC.length > 0
          ? result.filter(d =>
            d.rfc.toLowerCase().includes(this.searchRFC.toLowerCase())
          )
          : result;

      result =
        this.searchCte.length > 0
          ? result.filter(
          d => d.idClienteSAP == this.searchCte
          )
          : result;

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      //iniCreateDate: new Date(2020, 1, 1),
      //endCreateDate: new Date(2021, 1, 1),
      searchRazonSocial: "",
      searchRFC: "",
      searchCte: "",
      sizes: "col-md-3 col-sm-6",
      typeSelected: 0,
      statusSelected: "",
      assignDate: "",
      applicateDate: "",
      datePickerModal: false,
      searchQuery: "",
      searchedData: [],
      userFilters: [],
      statusFilters: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      tableData: [],
      fuseSearch: null
    };
  },
  async mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      //await this.getStatus();
      await this.getItems();
      this.$swal.close();
    },

    parseDatetime(dt) {
      var year = dt.getFullYear();
      var month = (dt.getMonth() + 1).toString().padStart(2, "0");
      var day = dt
        .getDate()
        .toString()
        .padStart(2, "0");
      return year + "-" + month + "-" + day;
    },

    /*changeFilters(filters) {
      console.log(filters);
    },*/
    /*
    filterTag(value, row) {
      var other = row.nombre === value;
      // console.log(this.searchedData);
      // console.log(other);
      return other;
    },
    filterStatus(value, row) {
      var other = row.estadoProspecto === value;
      // console.log(this.searchedData);
      // console.log(other);
      return other;
    },
    asigned(value) {
      var response = false;
      if (value > 1) {
        response = true;
      }
      return response;
    },

    */

    async getItems() {
      await this.$http.get(route("Clientes/getListadoClientesSAP")).then(
        response => {
          if (response.body.code === 200) {
            this.tableData = response.body.clientes;
            //console.log(response.body);

            for (let item of this.tableData) {
              //console.log("valor -> '" + item.fechaConfirmacionPedido + "'");
              //console.log(item.length);

              if (item.fechaConfirmacionPedido !== "") {
                //console.log("entro al if");
                var d = new Date(item.fechaConfirmacionPedido);
                item.fechaConfirmacionPedido = this.parseDatetime(d);
              } else {
                //console.log("entro al else");
                item.fechaConfirmacionPedido = "";
              }
            }
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        },
        error => {
          console.error(error);
        }
      );
    },

    DetailsItem(index, row, ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("clientes-detalles", row);
    },

    BillingItem(index, row, ref) {
      this.$router.push({ name: 'Facturas cliente', params: row })
      this.$refs[ref].doClose();
    },

    OrdersItem(index, row, ref) {
      this.$router.push({ name: 'Pedidos', params: row })
      this.$refs[ref].doClose();
    },

    AccountItem(item, row, ref){
      this.$router.push({ name: 'Estado cuenta cliente', params: row })
      this.$refs[ref].doClose();
    }
  }
};
</script>
